/* put your custom js here */

document.addEventListener("DOMContentLoaded", function() {
  // Select any homepage banner video dynamically
  const videoSection = document.querySelector('[id*="section_big_banner_slider"] video');

  if (videoSection) {
    videoSection.setAttribute('playsinline', true);
    videoSection.setAttribute('muted', true);
    videoSection.setAttribute('autoplay', true);

    // Try to play once it's loaded
    videoSection.addEventListener('canplay', () => {
      const playPromise = videoSection.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          console.log('Autoplay blocked; attempting muted inline playback.');
          videoSection.muted = true;
          videoSection.play();
        });
      }
    });
  } else {
    console.warn('No banner video found.');
  }
});


/* Adding B-Stock Disclaimer */
/* B-Stock Disclaimer (ES5-safe) */
(function () {
  // HTML for the disclaimer (no template literals)
  var DISCLAIMER_HTML = 'This is an Open Box item. ' +
    'By purchasing, you acknowledge and agree to the SMEG ' +
    '<a href="/pages/open-box-sales-policy" target="_blank" rel="noopener noreferrer" style="color:#b30000; font-weight:400; text-decoration:underline;">' +
    'Open Box Terms &amp; Conditions</a>. ' +
    'Please review them carefully before completing your order.';

  // Buy It Now button selector for your theme
  var ATC_SELECTOR = 'button.button.primary.w-full';

  function getTagsFromProductJson() {
    try {
      var jsonEl = document.querySelector('script[data-product-json]');
      if (!jsonEl) return [];
      var raw = jsonEl.textContent ? jsonEl.textContent.trim() : '';
      var data = JSON.parse(raw);
      if (data && Array.isArray(data.tags)) return data.tags;
    } catch (err) {
      console.warn('B-Stock script: JSON parse failed', err);
    }
    return [];
  }

  function hasBStock() {
    var tags = getTagsFromProductJson();
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toUpperCase() === 'B-STOCK') return true;
    }
    return false;
  }

  function insertDisclaimer() {
    var btn = document.querySelector(ATC_SELECTOR);
    if (!btn) { console.warn('B-Stock script: Buy It Now button not found'); return; }
    if (document.getElementById('b-stock-disclaimer')) return;

    var note = document.createElement('div');
    note.id = 'b-stock-disclaimer';
    note.setAttribute('role', 'note');
    // styles
    note.style.backgroundColor = '#ffe6e6';
    note.style.color = '#b30000';
    note.style.fontWeight = '400';
    note.style.padding = '12px 16px';
    note.style.marginTop = '12px';
    note.style.border = '1px solid #b30000';
    note.style.borderRadius = '6px';
    note.style.fontSize = '14px';
    note.style.lineHeight = '1.4';
    note.style.display = 'block';
    note.style.width = '100%';

    // render HTML (not text)
    note.innerHTML = DISCLAIMER_HTML;

    // insert below the ATC row
    var container = btn.parentElement;
    if (container && container.insertAdjacentElement) {
      container.insertAdjacentElement('afterend', note);
    } else {
      btn.insertAdjacentElement('afterend', note);
    }
  }

  function hidePromos() {
    var promos = document.querySelectorAll('.badge-text p');
    var hidden = 0;
    for (var i = 0; i < promos.length; i++) {
      var p = promos[i];
      var text = (p.innerText || '').toLowerCase();
      if (text.indexOf('extra year of warranty') !== -1 || text.indexOf('free standard shipping') !== -1) {
        var row = p.closest ? p.closest('.flex.gap-3.items-center') : null;
        (row || p).style.display = 'none';
        hidden++;
      }
    }
    if (hidden) console.log('B-Stock script: promos hidden = ' + hidden);
  }

  function apply() {
    if (!hasBStock()) return;
    insertDisclaimer();
    hidePromos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();

/* Hide B-STOCK products outside of Open Box collection */
(function () {
  const OPEN_BOX_HANDLE = "open-box-sale";
  const GRID_SELECTOR = ".boost-sd__product-list";

  // Don’t hide anything if we’re in the Open Box collection itself
  if (window.location.pathname.includes(`/collections/${OPEN_BOX_HANDLE}`)) {
    // console.log("B-Stock: inside Open Box Sale collection, not hiding anything.");
    return;
  }

  // Only run this on pages that should have product grids (adjust if needed)
  const isCollectionPage = /^\/collections(\/|$)/.test(window.location.pathname);
  const isSearchPage = /^\/search(\/|$)/.test(window.location.pathname);
  if (!isCollectionPage && !isSearchPage) return;

  function hideOpenBox() {
    const titles = document.querySelectorAll(".boost-sd__product-title");
    let hiddenCount = 0;

    titles.forEach((title) => {
      if (title.innerText.toLowerCase().includes("open box")) {
        const item = title.closest(".boost-sd__product-item");
        if (item && item.style.display !== "none") {
          item.style.display = "none";
          hiddenCount++;
        }
      }
    });

    if (hiddenCount > 0) {
      console.log(`B-Stock: hid ${hiddenCount} Open Box items`);
    }
  }

  function observeGrid() {
    let attempts = 0;
    const MAX_ATTEMPTS = 30;   // 30 seconds max
    const INTERVAL_MS = 1000;

    const tryAttach = () => {
      const grid = document.querySelector(GRID_SELECTOR);

      if (grid) {
        hideOpenBox(); // run once right away
        const observer = new MutationObserver(hideOpenBox);
        observer.observe(grid, { childList: true, subtree: true });
        console.log(`B-Stock: observer attached to ${GRID_SELECTOR}`);
        return;
      }

      attempts++;

      // Log only occasionally so it doesn't flood the console
      if (attempts === 1 || attempts % 5 === 0) {
        console.log(`B-Stock: product grid not found yet (attempt ${attempts}/${MAX_ATTEMPTS})`);
      }

      if (attempts < MAX_ATTEMPTS) {
        setTimeout(tryAttach, INTERVAL_MS);
      } else {
        console.warn(`B-Stock: giving up—${GRID_SELECTOR} never appeared on this page.`);
      }
    };

    tryAttach();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeGrid);
  } else {
    observeGrid();
  }
})();


/* === FINAL-FINAL: BOOST CART B-STOCK LIMIT (INSTANT VISUAL UPDATE, MULTI-FALLBACK) === */
(function () {
  const MAX_OPEN_BOX = 6;
  const OPEN_BOX_KEYWORD = "open box";
  let limitTriggered = false;

  function showCenteredWarning(message) {
    const existing = document.getElementById("bstock-warning-overlay");
    if (existing) existing.remove();

    const overlay = document.createElement("div");
    overlay.id = "bstock-warning-overlay";
    overlay.style.cssText = `
      position: fixed; inset: 0; width: 100vw; height: 100vh;
      background: rgba(0,0,0,0.55);
      display: flex; align-items: center; justify-content: center;
      z-index: 999999; animation: fadeIn 0.25s ease-out;
    `;

    const box = document.createElement("div");
    box.style.cssText = `
      background: #fff; border: 2px solid #b30000; border-radius: 10px;
      max-width: 480px; width: 90%; text-align: center;
      padding: 28px 24px; box-shadow: 0 4px 14px rgba(0,0,0,0.25);
      font-family: inherit; animation: popIn 0.25s ease-out;
    `;

    const title = document.createElement("h2");
    title.textContent = "⚠️ Open Box Limit Reached";
    title.style.cssText = `color:#b30000;font-size:20px;font-weight:700;margin-bottom:12px;`;

    const text = document.createElement("p");
    text.textContent = message;
    text.style.cssText = `color:#222;font-size:15px;line-height:1.5;margin:0 auto 16px;`;

    const btn = document.createElement("button");
    btn.textContent = "OK";
    btn.style.cssText = `
      background:#b30000;color:#fff;border:none;border-radius:6px;
      font-size:15px;font-weight:600;padding:10px 20px;cursor:pointer;
    `;
    btn.onclick = () => overlay.remove();

    box.appendChild(title);
    box.appendChild(text);
    box.appendChild(btn);
    overlay.appendChild(box);
    document.body.appendChild(overlay);
  }

  // Try all known ways to refresh Boost's drawer UI immediately
  function forceBoostDrawerRefresh() {
    let refreshed = false;

    // 1) Official-ish API if exposed
    try {
      if (window.BoostPFS && window.BoostPFS.CartDrawer && typeof window.BoostPFS.CartDrawer.refreshCart === "function") {
        window.BoostPFS.CartDrawer.refreshCart();
        refreshed = true;
      }
    } catch (e) { /* noop */ }

    // 2) Fire common Boost events
    try {
      document.dispatchEvent(new CustomEvent("boost:cart:refresh"));
      document.dispatchEvent(new CustomEvent("boost:cart:updated"));
    } catch (e) { /* noop */ }

    // 3) Try to “close & reopen” the drawer to force re-render
    setTimeout(() => {
      if (refreshed) return;

      const toggle =
        document.querySelector("[data-boost-cart-toggle]") ||
        document.querySelector(".boost-sd__cart-icon") ||
        document.querySelector("button[aria-controls*='boost'][aria-expanded]");

      const drawer =
        document.querySelector(".boost-sd__cart-drawer") ||
        document.querySelector(".boost-sd__drawer");

      if (toggle) {
        // simulate close → open
        try { toggle.click(); } catch (e) {}
        setTimeout(() => { try { toggle.click(); } catch (e) {} }, 300);
        refreshed = true;
      } else if (drawer) {
        // as a nudge, toggle a class that often triggers reflow
        drawer.classList.toggle("bstock-force-reflow");
        setTimeout(() => drawer.classList.toggle("bstock-force-reflow"), 200);
        refreshed = true;
      }

      // 4) Absolute last resort: gentle full refresh so UI matches backend
      setTimeout(() => {
        if (!refreshed) {
          try { window.location.reload(); } catch (e) {}
        }
      }, 800);
    }, 50);
  }

  async function checkOpenBoxLimit() {
    if (limitTriggered) return;

    try {
      const res = await fetch("/cart.js?timestamp=" + Date.now());
      const cart = await res.json();
      let count = 0;
      let lastItem = null;

      // Count all Open Box items and remember the last one
      cart.items.forEach(item => {
        const title = (item.title || "").toLowerCase();
        const tags = (item.tags || []).join(" ").toLowerCase();
        if (title.includes(OPEN_BOX_KEYWORD) || tags.includes("b-stock")) {
          count += item.quantity;
          lastItem = item;
        }
      });

      if (count > MAX_OPEN_BOX && lastItem) {
        limitTriggered = true;

        const toRemove = count - MAX_OPEN_BOX;
        const newQty = Math.max(lastItem.quantity - toRemove, 0);

        showCenteredWarning(
          `Each customer may only purchase up to ${MAX_OPEN_BOX} Open Box items total ` +
          `We’ve adjusted your cart to remove ${toRemove} extra item${toRemove > 1 ? 's' : ''}.`
        );

        // Adjust the last item's quantity
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: lastItem.key, quantity: newQty })
        })
          .then(() => {
            // Force drawer UI to reflect the change immediately
            forceBoostDrawerRefresh();
          })
          .catch(err => console.warn("Failed to update B-Stock quantity:", err))
          .finally(() => {
            setTimeout(() => (limitTriggered = false), 4000);
          });
      }
    } catch (err) {
      console.warn("B-Stock check failed", err);
    }
  }

  // Hook into Boost drawer lifecycle
  ["boost:cart:updated", "boost:cart:change", "boost:cart:open"].forEach(eventName =>
    document.addEventListener(eventName, () => setTimeout(checkOpenBoxLimit, 600))
  );

  // Fallback for add-to-cart clicks
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("form[action*='add'], button[name='add'], button.add-to-cart");
    if (btn) setTimeout(checkOpenBoxLimit, 1000);
  });
})();


/* Christmas Delivery Notice for All Products (ES5-safe) */
if (false) {
  (function () {
    // Messages
    var FRIDGE_HTML = '<strong>This product is not guaranteed for delivery before Christmas.</strong>';
    var NON_FRIDGE_HTML = '<strong>Order by December 14th to guarantee Christmas delivery.</strong> ' +
                          'Orders placed after this date may arrive after the holiday.';

    // Buy It Now button selector
    var ATC_SELECTOR = 'button.button.primary.w-full';

    // Get tags from product JSON
    function getTagsFromProductJson() {
      try {
        var jsonEl = document.querySelector('script[data-product-json]');
        if (!jsonEl) return [];
        var raw = jsonEl.textContent ? jsonEl.textContent.trim() : '';
        var data = JSON.parse(raw);
        if (data && Array.isArray(data.tags)) return data.tags;
      } catch (err) {
        console.warn('Christmas script: JSON parse failed', err);
      }
      return [];
    }

    // Check if product is a Refrigerator
    function isRefrigerator() {
      var tags = getTagsFromProductJson();
      var TARGET_TAG = 'BASE_INFO:::Product family:::Refrigerator';
      for (var i = 0; i < tags.length; i++) {
        if (String(tags[i]) === TARGET_TAG) return true;
      }
      return false;
    }

    // Insert notice under ATC
    function insertChristmasNotice(isFridge) {
      var btn = document.querySelector(ATC_SELECTOR);
      if (!btn) {
        console.warn('Christmas script: Buy It Now button not found');
        return;
      }
      if (document.getElementById('christmas-delivery-notice')) return;

      var note = document.createElement('div');
      note.id = 'christmas-delivery-notice';
      note.setAttribute('role', 'note');

      // Shared styling
      note.style.backgroundColor = '#fff7e6';
      note.style.color = '#b36b00';
      note.style.fontWeight = '400';
      note.style.padding = '12px 16px';
      note.style.marginTop = '12px';
      note.style.border = '1px solid #b36b00';
      note.style.borderRadius = '6px';
      note.style.fontSize = '14px';
      note.style.lineHeight = '1.4';
      note.style.display = 'block';
      note.style.width = '100%';

      note.innerHTML = isFridge ? FRIDGE_HTML : NON_FRIDGE_HTML;

      var container = btn.parentElement;
      if (container && container.insertAdjacentElement) {
        container.insertAdjacentElement('afterend', note);
      } else if (btn.insertAdjacentElement) {
        btn.insertAdjacentElement('afterend', note);
      }
    }

    function apply() {
      var fridge = isRefrigerator();
      insertChristmasNotice(fridge);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', apply);
    } else {
      apply();
    }
  })();
}

/* =========================================================
   HIDE "FREE STANDARD SHIPPING" UNDER ATC
   ONLY FOR: Refrigerators with weight > 200 lbs

   - Uses product JSON: <script data-product-json>...</script>
   - Checks product tag: BASE_INFO:::Product family:::Refrigerator
   - Computes max variant weight in LBS with smart fallback:
       * if unit exists -> convert
       * else if value > 1000 -> assume grams -> convert
       * else -> assume lbs (common setup)
   - Hides promo row under Buy It Now area
   - Uses MutationObserver so it survives theme re-renders
   ========================================================= */
(function () {
  // ======================
  // CONFIG
  // ======================
  var ATC_PROMO_TEXT = "free standard shipping"; // lowercase substring match
  var FRIDGE_TAG = "BASE_INFO:::Product family:::Refrigerator";
  var MIN_LBS = 200;

  // ======================
  // PRODUCT JSON HELPERS
  // ======================
  function getProductData() {
    try {
      var jsonEl = document.querySelector("script[data-product-json]");
      if (!jsonEl) return null;

      var raw = jsonEl.textContent ? jsonEl.textContent.trim() : "";
      if (!raw) return null;

      return JSON.parse(raw);
    } catch (err) {
      console.warn("Hide Free Shipping: product JSON parse failed", err);
      return null;
    }
  }

  function hasTag(data, tag) {
    if (!data || !data.tags || !data.tags.length) return false;
    for (var i = 0; i < data.tags.length; i++) {
      if (String(data.tags[i]) === tag) return true;
    }
    return false;
  }

  // ======================
  // WEIGHT CALCULATION
  // ======================
  function variantWeightToLbs(variant) {
    if (!variant) return 0;

    // Best case: Shopify grams
    if (typeof variant.grams === "number" && !isNaN(variant.grams) && variant.grams > 0) {
      return variant.grams / 453.59237;
    }

    // Fallback: weight + unit (some themes)
    var w = (typeof variant.weight === "number") ? variant.weight : 0;
    var unit = (variant.weight_unit || variant.weightUnit || "").toString().toLowerCase();

    if (!w || isNaN(w)) return 0;

    if (unit === "lb" || unit === "lbs") return w;
    if (unit === "kg") return w * 2.20462262;
    if (unit === "g") return w / 453.59237;
    if (unit === "oz") return w / 16;

    // SMART GUESSING (because your store uses lbs, but JSON might be grams)
    // - If it's a huge number, it's almost certainly grams.
    // - If it's a normal number, treat as pounds.
    if (w > 1000) {
      return w / 453.59237; // assume grams
    }
    return w; // assume lbs
  }

  function maxVariantWeightLbs(data) {
    if (!data || !data.variants || !data.variants.length) return 0;

    var max = 0;
    for (var i = 0; i < data.variants.length; i++) {
      var lbs = variantWeightToLbs(data.variants[i]);
      if (lbs > max) max = lbs;
    }
    return max;
  }

  // ======================
  // DOM TARGET + HIDE
  // ======================
  function hideFreeShippingRow() {
    var promos = document.querySelectorAll(".badge-text p");
    var hidden = 0;

    for (var i = 0; i < promos.length; i++) {
      var p = promos[i];
      var text = (p.innerText || p.textContent || "").toLowerCase();

      if (text.indexOf(ATC_PROMO_TEXT) !== -1) {
        var row = p.closest ? p.closest(".flex.gap-3.items-center") : null;
        (row || p).style.display = "none";
        hidden++;
      }
    }

    if (hidden) console.log("Hide Free Shipping: hidden rows = " + hidden);
  }

  // ======================
  // MAIN APPLY
  // ======================
  function apply() {
    var data = getProductData();
    if (!data) return;

    // Condition 1: Refrigerator tag
    if (!hasTag(data, FRIDGE_TAG)) return;

    // Condition 2: Weight > 200 lbs
    var maxLbs = maxVariantWeightLbs(data);

    // OPTIONAL: quick console visibility for troubleshooting
    // console.log("Hide Free Shipping: maxLbs =", maxLbs, "handle =", data.handle);

    if (maxLbs <= MIN_LBS) return;

    hideFreeShippingRow();

    // Keep hiding if theme re-renders later
    var start = Date.now();
    var obs = new MutationObserver(function () {
      hideFreeShippingRow();
      if (Date.now() - start > 8000) {
        try { obs.disconnect(); } catch (e) {}
      }
    });

    try {
      obs.observe(document.body, { childList: true, subtree: true });
    } catch (e) {
      setTimeout(hideFreeShippingRow, 500);
      setTimeout(hideFreeShippingRow, 1500);
      setTimeout(hideFreeShippingRow, 3000);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply);
  } else {
    apply();
  }
})();
